/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-use-before-define */
/* eslint-disable radix */

import Swiper from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { getScreenSizeType } from './util';

const isDesktop = getScreenSizeType().indexOf('desktop') > -1;

const SWIPERID = '.js-usp-swiper';
const MOBILE_BREAKPOINT = '(max-width: 1024px)';

const UspTiles = (() => {
    function handleSwiper() {
        if (!$(SWIPERID).length > 0) {
            return;
        }

        const slideNumber = $(SWIPERID).find('.swiper-slide').length;

        new Swiper(SWIPERID, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination, Scrollbar, A11y],
            breakpoint: MOBILE_BREAKPOINT,
            speed: 500,
            spaceBetween: 0,
            loopedSlides: slideNumber,
            slidesPerView: 'auto',
            centeredSlides: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 'auto',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            a11y: {
                prevSlideMessage: `${window.resources['slider.prev.slide.label']}`,
                nextSlideMessage: `${window.resources['slider.next.slide.label']}`,
                firstSlideMessage: `${window.resources['slider.first.slide.label']}`,
                lastSlideMessage: `${window.resources['slider.last.slide.label']}`,
            },
        });
    }

    function fadeInAnimation() {
        const uspBlock = document.querySelectorAll('.usp-slide');

        if (!isDesktop) {
            uspBlock.forEach(slide => {
                slide.classList.remove('hidden');
            });
        }
    }

    /**
     * @description Function for navigating to checkout and pushing gtm data to dataLayer
    */
    function joinNowBtnHandler() {
        $('.js-usp-block__btn').on('click', (e) => {
            e.preventDefault();
            const hrefUrl = $('.js-usp-block__btn').data('href-url');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                event: 'precheckout',
                step: '1',
                component_name: 'join now',
            });
            window.location.href = hrefUrl;
        });
    }

    return {
        init() {
            handleSwiper();
            fadeInAnimation();
            joinNowBtnHandler();
        },
    };
})();

export default (() => {
    $(UspTiles.init);
})();
